import { computed, inject, Injectable, linkedSignal, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';

@Injectable()
export class EmbeddedShellService {
  readonly router = inject(Router);
  readonly rootUrl = signal<string | undefined>(undefined);

  readonly #currentUrlRouterUrl = toSignal(
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map((o) => o?.urlAfterRedirects ?? o?.url)
    ),
    { initialValue: undefined }
  );

  readonly currentUrl = linkedSignal(() => this.#currentUrlRouterUrl());

  readonly isRoot = computed(() => this.currentUrl() === this.rootUrl());
}
